import { render, staticRenderFns } from "./indicators1.vue?vue&type=template&id=07adbca0&scoped=true&"
import script from "./indicators1.vue?vue&type=script&lang=js&"
export * from "./indicators1.vue?vue&type=script&lang=js&"
import style0 from "./indicators1.vue?vue&type=style&index=0&id=07adbca0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07adbca0",
  null
  
)

export default component.exports